import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 1000 500",
  "content": "<symbol viewBox=\"0 0 1000 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right\">\n<path d=\"M50 231.151C344.554 229.668 643.448 176.302 933.661 226.703C1003.9 238.901 829.005 329.308 762.462 354.885C724.524 369.467 813.176 291.182 841.57 262.102C858.084 245.189 876.778 230.235 896.658 217.448C902.231 213.864 922.061 217.247 916.246 214.072C866.113 186.697 812.295 166.69 760.32 143\" stroke=\"currentColor\" stroke-width=\"6.18412\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol